import React, { useEffect, useState } from 'react';
import { Collapse } from 'antd';
import axios from 'axios';

const { Panel } = Collapse;

const TestCaseList = ({ userDetails }) => {
  const [displayTestCases, setDisplayTestCases] = useState([]);

  useEffect(() => {
    const fetchTestCases = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/testcase/${userDetails.email}`);
        setDisplayTestCases(response.data);
      } catch (error) {
        console.error("Error fetching test cases:", error);
      }
    };
    fetchTestCases();
  }, [userDetails]);

  return (
    <Collapse style={{ marginTop: '20px' }}>
      {displayTestCases.map((testcase, index) => (
        <Panel key={testcase.id} header={testcase.name}>
          <p><strong>Testcase ID :</strong> {testcase.id}</p>
          <p><strong>Testcase Input :</strong> {testcase.input.toUpperCase()}</p>
          <p><strong>TestCase Output :</strong> {testcase.output.toUpperCase()}</p>
          <p><strong>TestCase Agent Name :</strong> {testcase.agent?.name}</p>
        </Panel>
      ))}
    </Collapse>
  );
};

export default TestCaseList;
